import { render, staticRenderFns } from "./licensePlateList.vue?vue&type=template&id=652059cf&scoped=true"
import script from "./licensePlateList.vue?vue&type=script&lang=js"
export * from "./licensePlateList.vue?vue&type=script&lang=js"
import style0 from "./licensePlateList.vue?vue&type=style&index=0&id=652059cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652059cf",
  null
  
)

export default component.exports